import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
    selector: C.EWIZ_LAST_REGISTERED_PLMN_CONFIGURATION,
    templateUrl: "./last-registered-plmn-configuration.component.html",
    standalone: false
})
export class EWizLastRegisteredPLMNConfigurationComponent extends EWizDynamicBaseClassComponent {}
